import React, { useContext, useMemo } from 'react';
import { isEmpty } from 'lodash/lang';

import { PageInfoHeader } from 'components/PageInfoHeader/PageInfoHeader';

import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';
import { toFormattedBill } from '../../../../../services/financial';
import { Amount } from '../../shared/amount-view/Amount/Amount';
import { InvoiceContext } from '../NewInvoiceContext';

import InvoiceFilter from './InvoiceFilter/InvoiceFilter';

import './InvoiceTopSection.scss';

export const InvoiceTopSection = () => {
  const { downloadCSV, downloadNSCSV, ledgerEvents, isExportNsDisabled, selectedEventIds } = useContext(InvoiceContext);

  const totalAmount = useMemo(
    function() {
      return ledgerEvents?.reduce((accumulator, currentValue) => accumulator + currentValue.invoiceAmount, 0);
    },
    [ledgerEvents]
  );
  const unbilledAmount = useMemo(
    function() {
      return ledgerEvents?.reduce(
        (accumulator, currentValue) =>
          !currentValue.invoiceNumber ? accumulator + currentValue.invoiceAmount : accumulator,
        0
      );
    },
    [ledgerEvents]
  );
  const selectedAmount = useMemo(() => {
    return ledgerEvents
      ?.filter(event => selectedEventIds.includes(event.tableId))
      .reduce((accumulator, currentValue) => accumulator + currentValue.invoiceAmount, 0);
  }, [ledgerEvents, selectedEventIds]);

  return (
    <PageInfoHeader
      className="invoice-page-header"
      pageInfo={
        <React.Fragment>
          <PageInfoHeader.AdditionalInfo title={'Total Amount'} data-testid="total-amount-info">
            <Amount coinsAmount={totalAmount} customCoinsFormat={toFormattedBill} />
          </PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo title={'Unbilled Amount'} data-testid="unbilled-amount-info">
            <Amount coinsAmount={unbilledAmount} customCoinsFormat={toFormattedBill} />
          </PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo title={'Selected Amount'} data-testid="selected-amount-info">
            <Amount coinsAmount={selectedAmount} customCoinsFormat={toFormattedBill} />
          </PageInfoHeader.AdditionalInfo>
        </React.Fragment>
      }
      right={
        <ButtonGroup>
          <Button
            className="its-export"
            size="h28"
            priority="medium"
            onClick={downloadCSV}
            disabled={isEmpty(ledgerEvents)}
          >
            Export
          </Button>
          <Button
            className="its-export"
            size="h28"
            priority="medium"
            onClick={downloadNSCSV}
            disabled={isExportNsDisabled}
          >
            Export NS
          </Button>
        </ButtonGroup>
      }
    >
      <InvoiceFilter />
    </PageInfoHeader>
  );
};
